import { createIcon, IconProps } from '@chakra-ui/react';
import * as brands from '@fortawesome/free-brands-svg-icons';
import * as duotone from '@fortawesome/pro-duotone-svg-icons';
import * as regular from '@fortawesome/pro-regular-svg-icons';
import * as solid from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import React, { CSSProperties } from 'react';

export type IconLib = 'regular' | 'solid' | 'duotone';

export const IconMap = {
  'arrow-left-long': {
    duotone: duotone.faArrowLeftLong,
    regular: regular.faArrowLeftLong,
    solid: solid.faArrowLeftLong,
  },
  'arrow-right-long': {
    duotone: duotone.faArrowRightLong,
    regular: regular.faArrowRightLong,
    solid: solid.faArrowRightLong,
  },
  'arrow-trend-up': { duotone: duotone.faArrowTrendUp, regular: regular.faArrowTrendUp, solid: solid.faArrowTrendUp },
  'arrow-up-from-bracket': {
    duotone: duotone.faArrowUpFromBracket,
    regular: regular.faArrowUpFromBracket,
    solid: solid.faArrowUpFromBracket,
  },
  'arrow-up-right-from-square': {
    duotone: duotone.faArrowUpRightFromSquare,
    regular: regular.faArrowUpRightFromSquare,
    solid: solid.faArrowUpRightFromSquare,
  },
  at: { duotone: duotone.faAt, regular: regular.faAt, solid: solid.faAt },
  bath: { duotone: duotone.faBath, regular: regular.faBath, solid: solid.faBath },
  'bed-front': { duotone: duotone.faBedFront, regular: regular.faBedFront, solid: solid.faBedFront },
  bell: { duotone: duotone.faBell, regular: regular.faBell, solid: solid.faBell },
  bolt: { duotone: duotone.faBolt, regular: regular.faBolt, solid: solid.faBolt },
  briefcase: { duotone: duotone.faBriefcase, regular: regular.faBriefcase, solid: solid.faBriefcase },
  building: { duotone: duotone.faBuilding, regular: regular.faBuilding, solid: solid.faBuilding },
  buildings: { duotone: duotone.faBuildings, regular: regular.faBuildings, solid: solid.faBuildings },
  calendar: { duotone: duotone.faCalendar, regular: regular.faCalendar, solid: solid.faCalendar },
  'caret-down': { duotone: duotone.faCaretDown, regular: regular.faCaretDown, solid: solid.faCaretDown },
  'caret-right': { duotone: duotone.faCaretRight, regular: regular.faCaretRight, solid: solid.faCaretRight },
  'caret-up': { duotone: duotone.faCaretUp, regular: regular.faCaretUp, solid: solid.faCaretUp },
  'chart-line': { duotone: duotone.faChartLine, regular: regular.faChartLine, solid: solid.faChartLine },
  'chart-pie': { duotone: duotone.faChartPie, regular: regular.faChartPie, solid: solid.faChartPie },
  'chart-pie-simple': {
    duotone: duotone.faChartPieSimple,
    regular: regular.faChartPieSimple,
    solid: solid.faChartPieSimple,
  },
  check: { duotone: duotone.faCheck, regular: regular.faCheck, solid: solid.faCheck },
  'chess-king-piece': {
    duotone: duotone.faChessKingPiece,
    regular: regular.faChessKingPiece,
    solid: solid.faChessKingPiece,
  },
  'chevron-down': { duotone: duotone.faChevronDown, regular: regular.faChevronDown, solid: solid.faChevronDown },
  'chevron-left': { duotone: duotone.faChevronLeft, regular: regular.faChevronLeft, solid: solid.faChevronLeft },
  'chevron-right': { duotone: duotone.faChevronRight, regular: regular.faChevronRight, solid: solid.faChevronRight },
  circle: { duotone: duotone.faCircle, regular: regular.faCircle, solid: solid.faCircle },
  'circle-check': { duotone: duotone.faCircleCheck, regular: regular.faCircleCheck, solid: solid.faCircleCheck },
  'circle-dollar-to-slot': {
    duotone: duotone.faCircleDollarToSlot,
    regular: regular.faCircleDollarToSlot,
    solid: solid.faCircleDollarToSlot,
  },
  'circle-exclamation': {
    duotone: duotone.faCircleExclamation,
    regular: regular.faCircleExclamation,
    solid: solid.faCircleExclamation,
  },
  'circle-info': { duotone: duotone.faCircleInfo, regular: regular.faCircleInfo, solid: solid.faCircleInfo },
  'coin-up': { duotone: duotone.faCoinVertical, regular: regular.faCoinVertical, solid: solid.faCoinVertical },
  comment: { duotone: duotone.faComment, regular: regular.faComment, solid: solid.faComment },
  'credit-card': { duotone: duotone.faCreditCard, regular: regular.faCreditCard, solid: solid.faCreditCard },
  'dollar-sign': { duotone: duotone.faDollarSign, regular: regular.faDollarSign, solid: solid.faDollarSign },
  'ellipsis-v': { duotone: duotone.faEllipsisV, regular: regular.faEllipsisV, solid: solid.faEllipsisV },
  envelope: { duotone: duotone.faEnvelope, regular: regular.faEnvelope, solid: solid.faEnvelope },
  eye: { duotone: duotone.faEye, regular: regular.faEye, solid: solid.faEye },
  'eye-slash': { duotone: duotone.faEyeSlash, regular: regular.faEyeSlash, solid: solid.faEyeSlash },
  facebook: { duotone: brands.faFacebook, regular: brands.faFacebook, solid: brands.faFacebook },
  file: { duotone: duotone.faFile, regular: regular.faFile, solid: solid.faFile },
  'file-arrow-down': {
    duotone: duotone.faFileArrowDown,
    regular: regular.faFileArrowDown,
    solid: solid.faFileArrowDown,
  },
  'file-contract': { duotone: duotone.faFileContract, regular: regular.faFileContract, solid: solid.faFileContract },
  'file-invoice': { duotone: duotone.faFileInvoice, regular: regular.faFileInvoice, solid: solid.faFileInvoice },
  flame: { duotone: duotone.faFlame, regular: regular.faFlame, solid: solid.faFlame },
  'graduation-cap': {
    duotone: duotone.faGraduationCap,
    regular: regular.faGraduationCap,
    solid: solid.faGraduationCap,
  },
  grid: { duotone: duotone.faGrid, regular: regular.faGrid, solid: solid.faGrid },
  'grid-2-2': { duotone: duotone.faGrid2, regular: regular.faGrid2, solid: solid.faGrid2 },
  'hand-holding-seedling': {
    duotone: duotone.faHandHoldingSeedling,
    regular: regular.faHandHoldingSeedling,
    solid: solid.faHandHoldingSeedling,
  },
  'hand-wave': { duotone: duotone.faHandWave, regular: regular.faHandWave, solid: solid.faHandWave },
  handshake: { duotone: duotone.faHandshake, regular: regular.faHandshake, solid: solid.faHandshake },
  heart: { duotone: duotone.faHeart, regular: regular.faHeart, solid: solid.faHeart },
  'helmet-safety': { duotone: duotone.faHelmetSafety, regular: regular.faHelmetSafety, solid: solid.faHelmetSafety },
  house: { duotone: duotone.faHouse, regular: regular.faHouse, solid: solid.faHouse },
  'id-card': { duotone: duotone.faIdCard, regular: regular.faIdCard, solid: solid.faIdCard },
  image: { duotone: duotone.faImage, regular: regular.faImage, solid: solid.faImage },
  inbox: { duotone: duotone.faInbox, regular: regular.faInbox, solid: solid.faInbox },
  key: { duotone: duotone.faKey, regular: regular.faKey, solid: solid.faKey },
  'link-simple': { duotone: duotone.faLinkSimple, regular: regular.faLinkSimple, solid: solid.faLinkSimple },
  linkedIn: { duotone: brands.faLinkedin, regular: brands.faLinkedin, solid: brands.faLinkedin },
  'list-timeline': { duotone: duotone.faListTimeline, regular: regular.faListTimeline, solid: solid.faListTimeline },
  'location-dot': { duotone: duotone.faLocationDot, regular: regular.faLocationDot, solid: solid.faLocationDot },
  lock: { duotone: duotone.faLock, regular: regular.faLock, solid: solid.faLock },
  map: { duotone: duotone.faMap, regular: regular.faMap, solid: solid.faMap },
  'map-location-dot': { duotone: duotone.faMapLocationDot, regular: regular.faMapLocationDot, solid: solid.faMapLocationDot },
  'map-pin': { duotone: duotone.faMapPin, regular: regular.faMapPin, solid: solid.faMapPin },
  'octogon-exclamation': {
    duotone: duotone.faOctagonExclamation,
    regular: regular.faOctagonExclamation,
    solid: solid.faOctagonExclamation,
  },
  'pen-to-square': { duotone: duotone.faPenToSquare, regular: regular.faPenToSquare, solid: solid.faPenToSquare },
  phone: { duotone: duotone.faPhone, regular: regular.faPhone, solid: solid.faPhone },
  'piggy-bank': { duotone: duotone.faPiggyBank, regular: regular.faPiggyBank, solid: solid.faPiggyBank },
  plus: { duotone: duotone.faPlus, regular: regular.faPlus, solid: solid.faPlus },
  'right-from-bracket': {
    duotone: duotone.faRightFromBracket,
    regular: regular.faRightFromBracket,
    solid: solid.faRightFromBracket,
  },
  robot: { duotone: duotone.faRobot, regular: regular.faRobot, solid: solid.faRobot },
  'ruler-triangle': {
    duotone: duotone.faRulerTriangle,
    regular: regular.faRulerTriangle,
    solid: solid.faRulerTriangle,
  },
  'scale-balanced': {
    duotone: duotone.faScaleBalanced,
    regular: regular.faScaleBalanced,
    solid: solid.faScaleBalanced,
  },
  'scale-unbalanced': {
    duotone: duotone.faScaleUnbalanced,
    regular: regular.faScaleUnbalanced,
    solid: solid.faScaleUnbalanced,
  },
  'signal-bars-good': { duotone: duotone.faSignalBars, regular: regular.faSignalBars, solid: solid.faSignalBars },
  signature: { duotone: duotone.faSignature, regular: regular.faSignature, solid: solid.faSignature },
  sitemap: { duotone: duotone.faSitemap, regular: regular.faSitemap, solid: solid.faSitemap },
  sparkles: { duotone: duotone.faSparkles, regular: regular.faSparkles, solid: solid.faSparkles },
  star: { duotone: duotone.faStar, regular: regular.faStar, solid: solid.faStar },
  tag: { duotone: duotone.faTag, regular: regular.faTag, solid: solid.faTag },
  'thumbs-down': { duotone: duotone.faThumbsDown, regular: regular.faThumbsDown, solid: solid.faThumbsDown },
  'thumbs-up': { duotone: duotone.faThumbsUp, regular: regular.faThumbsUp, solid: solid.faThumbsUp },
  times: { duotone: duotone.faTimes, regular: regular.faTimes, solid: solid.faTimes },
  trash: { duotone: duotone.faTrash, regular: regular.faTrash, solid: solid.faTrash },
  'trash-can': { duotone: duotone.faTrashCan, regular: regular.faTrashCan, solid: solid.faTrashCan },
  triangle: { duotone: duotone.faTriangle, regular: regular.faTriangle, solid: solid.faTriangle },
  'triangle-exclamation': {
    duotone: duotone.faTriangleExclamation,
    regular: regular.faTriangleExclamation,
    solid: solid.faTriangleExclamation,
  },
  twitter: { duotone: brands.faTwitter, regular: brands.faTwitter, solid: brands.faTwitter },
  university: { duotone: duotone.faUniversity, regular: regular.faUniversity, solid: solid.faUniversity },
  unlock: { duotone: duotone.faUnlock, regular: regular.faUnlock, solid: solid.faUnlock },
  user: { duotone: duotone.faUser, regular: regular.faUser, solid: solid.faUser },
  'users-line': { duotone: duotone.faUsersLine, regular: regular.faUsersLine, solid: solid.faUsersLine },
};

export const createChakraIconFromFontAwesomeIcon = (faIconDefinition: regular.IconDefinition, props?: IconProps) => {
  const { icon, iconName } = faIconDefinition;
  return createIcon({
    d: icon[4] as string,
    defaultProps: props,
    displayName: iconName,
    viewBox: `0 0 ${icon[0]} ${icon[1]}`,
  });
};

export const Icon: React.FC<
  {
    icon: keyof typeof IconMap;
    variant?: IconLib;
  } & IconProps
> = ({ icon, variant = 'solid', ...props }) => {
  const iconDefinition = IconMap[icon][variant];
  const Comp = createChakraIconFromFontAwesomeIcon(iconDefinition, props);
  return <Comp />;
};

export const DuotoneIcon: React.FC<
  Omit<FontAwesomeIconProps, 'icon'> & {
    icon: keyof typeof IconMap;
    primaryColor?: string;
    secondaryColor?: string;
    swapOpacity?: boolean;
  }
> = ({ icon, primaryColor, secondaryColor, swapOpacity = false, ...props }) => {
  return (
    <FontAwesomeIcon
      icon={IconMap[icon]['duotone']}
      className={swapOpacity ? 'fa-swap-opacity' : ''}
      style={
        {
          '--fa-primary-color': primaryColor,
          '--fa-secondary-color': secondaryColor,
        } as CSSProperties
      }
      {...props}
    />
  );
};
